import { useState, useEffect } from "react";
import { reset } from "../services/reset";
import { useLocation } from "react-router-dom";

export function ResetPass() {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const location = useLocation();

  // Obtener el valor de 'email' desde la URL cuando el componente se monta
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailFromURL = params.get("email");
    if (emailFromURL) {
      setEmail(emailFromURL);
    }
  }, [location]);

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      await reset(email).then((data) => {
        console.log(data);
        if (typeof data.message !== "undefined") {
          const regex = /(<([^>]+)>)/gi;
          const cleanErrorMessage = data.message.replace(regex, "");
          setErrorMessage(cleanErrorMessage);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div id='content' className='login-page'>
      <form onSubmit={handleReset}>
        <div className='login-full'>
          <div className='login-bg'></div>
          <div className='login-content'>
            <div className='login-form'>
              <h3>Nueva contraseña</h3>
              <p className='login-copy'>Por favor, introduzca su email para poder enviarle un código para restaurar su contraseña</p>
              <div className='login-input'>
                <div className='field'>
                  <label>Email de usuario</label>
                  <div className='control'>
                    <input
                      className='input'
                      required
                      type='email'
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <button className='button is-link' type='submit'>
                  Enviar Código
                </button>
              </div>
              {errorMessage && <p className='login-error'>{errorMessage}</p>}
            </div>
            <div className='login-rights'>
              <p>© {getCurrentYear()} TAVAD</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
